export function noop(...args: any[]) {
    // do nothing
}
